/**
 * @generated SignedSource<<339ea93e700dc20650af96f0c43552b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveAdminFromOrganizationInput = {
  email: string;
  organizationId: string;
};
export type useAdminMutationsRemoveFromOrganizationMutation$variables = {
  input: RemoveAdminFromOrganizationInput;
};
export type useAdminMutationsRemoveFromOrganizationMutation$data = {
  readonly removeAdminFromOrganization: {
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
  };
};
export type useAdminMutationsRemoveFromOrganizationMutation = {
  response: useAdminMutationsRemoveFromOrganizationMutation$data;
  variables: useAdminMutationsRemoveFromOrganizationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "removeAdminFromOrganization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsRemoveFromOrganizationMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsRemoveFromOrganizationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a6837f5c0fdfd44b1742b74b099485b4",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsRemoveFromOrganizationMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsRemoveFromOrganizationMutation(\n  $input: RemoveAdminFromOrganizationInput!\n) {\n  removeAdminFromOrganization(input: $input) {\n    id\n    email\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "3755c35869df3562200963a164c9416a";

export default node;
